import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { BeautybookService } from '@features/beautybook/services/beautybook.service';
import { faImage, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ImageCroppedEvent, base64ToFile } from 'ngx-image-cropper';
import { isPlatformBrowser } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'fc-selfie-upload-dialog',
  templateUrl: './selfie-upload-dialog.component.html',
  styleUrls: ['./selfie-upload-dialog.component.css'],
})
export class SelfieUploadDialogComponent implements OnInit {
  faSpinner = faSpinner;
  faTimes = faTimes;
  faImage = faImage;

  isSubmitted: boolean = false;
  loading: boolean = false;
  errMessage: string = '';


  imageChangedEvent: any = '';
  croppedImage: any = '';
  isBrowser = isPlatformBrowser(this.platformId);
  @Output() changeSelfie: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public ref: DynamicDialogRef,
    private sanitizer: DomSanitizer,
    public config: DynamicDialogConfig,
    private beautybookService: BeautybookService
  ) {

  }

  ngOnInit(): void {}
  onCroppSelfie(selfie: any) {
    this.changeSelfie.emit(selfie);
    this.onCloseModal(selfie);
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.croppedImage = base64ToFile(event.base64);
    }
  }
  submitSelfie() {
    this.loading = true
    let formData = new FormData();
    console.log(this.croppedImage)
    formData.append('image', this.croppedImage);
    this.beautybookService.uploadSelfie(formData).subscribe((data) => {
      this.onCroppSelfie(data);
      this.loading = false
    });
  }

  onCloseModal(selfie: any = null) {
    if (selfie) {
      this.ref.close(selfie);
    } else {
      this.ref.close();
    }
  }
}
